import { t } from "@lingui/core/macro";

import {
  useBuildset,
  useBuildsetManifest,
  getBuildsetUrls,
} from "_/data/buildsets";
import { formatBuildsetLabel } from "_/utils/buildset-display";

import { useParams } from "_/components/router";
import { JsonTree } from "_/components/json-tree";
import { Button } from "_/components/button";
import { Icon } from "_/components/icon";

import { Uuid } from "_/types";

import { AdminPage } from "../../admin-page";

import * as S from "./styled";

export const Buildset = () => {
  const { id } = useParams<{ id: Uuid }>();
  const { data: buildset } = useBuildset(id);
  const { data: manifest } = useBuildsetManifest(id);
  const { isoUrl, raucbUrl } = getBuildsetUrls(id, buildset?.displayVersion);
  const label = formatBuildsetLabel(buildset);

  const title = `${t`common.buildset`}: ${label.value}`;

  const downloadButtons = (
    <S.ButtonRow>
      <a href={isoUrl} title={label.fullName ?? label.value} download>
        <Button>
          <Icon variant="FileDownload" />
          {t`components.buildset.download-iso`}
        </Button>
      </a>
      <a href={raucbUrl} title={label.fullName ?? label.value} download>
        <Button>
          <Icon variant="FileDownload" />
          {t`components.buildset.download-raucb`}
        </Button>
      </a>
    </S.ButtonRow>
  );

  return (
    <AdminPage title={title} headerControls={downloadButtons}>
      {manifest && <JsonTree hideRoot data={manifest} />}
    </AdminPage>
  );
};
